// extracted by mini-css-extract-plugin
export var actions = "_rd-4";
export var item = "_rd-1";
export var price = "_rd-3";
export var quantity = "_rd-2";
export var table = "_rd-0";